import Context from "@/context/Context";
import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";

import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import PageHead from "@/pages/Head";
import BackToTop from "@/pages/backToTop";
import FooterOne from "@/components/Footer/Footer-One";
import AboutDescription from "@/components/About-Us/AboutDescription";

import Separator from "@/components/Common/Separator";
import Banner from "@/components/About-Us-02/Banner";


const AboutUsPageTwo = () => {
  return (
    <>
      <PageHead title="About Us - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerType="" />
          <MobileMenu />

          <div className="rbt-banner-area rbt-banner-8 variation-02">
            <div className="container">
              <Banner />
            </div>
          </div>
          <div className="rbt-call-to-action-area rbt-section-gap bg-gradient-8">
            <div className="rbt-callto-action rbt-cta-default style-6">
              <AboutDescription 
                title='Nuestra Misión'
                description='La ASOCIACIÓN PARA LA EDUCACION BILINGÜE CENTRO EDUCATIVO MENFIS tiene como misión a partir del 2023,  formar estudiantes bilingües líderes, con una base sólida en valores y responsabilidad ambiental, con gran proyección al emprendimiento, teniendo un pensamiento crítico y explotando al máximo capacidades, talentos y habilidades propias que desarrollen durante su proceso formativo, convirtiéndose en personas altamente competentes que impacten la sociedad positivamente, así como los demás ámbitos en los que puedan participar ayudados por el dominio de una lengua extranjera como el inglés.'
              />
            </div>
          </div>
          <div className="rbt-call-to-action-area rbt-section-gap bg-gradient-3">
            <div className="rbt-callto-action rbt-cta-default style-6">
              <AboutDescription 
                title='Nuestra Visión'
                description='Nuestra institución proyecta para el año 2028 ser el primer colegio bilingüe del municipio, que marque el camino y sirva como modelo para proyectos educativos tanto privados como públicos que apunten al mejoramiento del perfil de nuestros estudiantes como egresados bilingües con las competencias y valores para enfrentar un mundo globalizado cuya lengua de convergencia ya es el inglés. La participación de docentes nativos de diferentes países que vendrán a través de la fundación Minga House, impactará no solamente el aprendizaje del inglés a nivel institucional y municipal sino también el potencial turístico de nuestro municipio.'
              />
            </div>
          </div>
          <div className="rbt-call-to-action-area rbt-section-gap bg-gradient-7">
            <div className="rbt-callto-action rbt-cta-default style-6">
              <AboutDescription 
                title='Nuestra Historia'
                description='El Centro Educativo Menfis, fue fundado el 6 de noviembre del año 1997, cuyas gestoras fueron Patricia Gómez Palacio, licenciada en filosofía y Letras; Yaneth Gómez Palacio, profesional en fonoaudiología; quienes con el apoyo económico del señor Bernabé Antonio Gómez Gallego, dieron comienzo a este gran proyecto que tenía como visión trabajar por una comunidad chinchinense que, de acuerdo a las encuestas realizadas, buscaba el cambio social por medio de la educación.'
                descriptionExtended='Estas dos profesionales iniciaron con la idea y el compromiso de hacer realidad un cambio en la educación, en donde la parte integral del niño, niña y adolescente sea trabajando evolutivamente y se le brinde la atención a la unidad: mente y cuerpo; para un desarrollo productivo del individuo en Chinchiná. En el año 1998 iniciamos con 27 estudiantes, desde sala cuna hasta grado 5° de básica primaria, terminando este mismo con 40 estudiantes, dando un balance positivo, motivándonos para seguir adelante.'
              />
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default AboutUsPageTwo;
